import { useStore } from '@ozdao/martyrs/modules/core/client';
import { reactive } from 'vue';

// UI state
export const uiState = reactive({
  isContactFormOpen: false,
  isMobileMenuOpen: false,
  cursorLabel: {
    visible: false,
    text: ''
  }
});

// Cursor label actions
export const showCursorLabel = (text) => {
  uiState.cursorLabel.text = text;
  uiState.cursorLabel.visible = true;
};

export const hideCursorLabel = () => {
  uiState.cursorLabel.visible = false;
};

// UI actions
export const openContactForm = () => {
  uiState.isContactFormOpen = true;
  if (typeof document !== 'undefined') {
    document.documentElement.classList.add('popup_contact_visible');
    document.body.style.overflow = 'hidden';
  }
};

export const closeContactForm = () => {
  uiState.isContactFormOpen = false;
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove('popup_contact_visible');
    document.body.style.overflow = '';
  }
};

export const toggleMobileMenu = () => {
  uiState.isMobileMenuOpen = !uiState.isMobileMenuOpen;
  if (typeof document !== 'undefined') {
    document.body.style.overflow = uiState.isMobileMenuOpen ? 'hidden' : '';
  }
};

export const closeMobileMenu = () => {
  uiState.isMobileMenuOpen = false;
  if (typeof document !== 'undefined') {
    document.body.style.overflow = '';
  }
};

export function getStore() {
  return useStore();
}

export { useStore };

export default useStore();

